import React from "react"
import styled from "styled-components"

import { Container } from "../global"

const Sunrise = () => (
  <SunriseBand>
    <Container>
      <BigLine>“The sun rises anyway.”</BigLine>
      <SmallLine>
        Missed a day? So has everyone here. Day never guilts you — it just
        leaves the door open. Come back, add your day, and the streak of you
        being you continues.
      </SmallLine>
    </Container>
  </SunriseBand>
)

export default Sunrise

const SunriseBand = styled.section`
  background: linear-gradient(160deg, #071435 0%, #1d2b57 55%, #db9840 160%);
  padding: 90px 0;
  text-align: center;
`

const BigLine = styled.h3`
  color: #ffde59;
  margin: 0 auto 20px;
  font-size: 34px;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    font-size: 26px;
  }
`

const SmallLine = styled.p`
  max-width: 560px;
  margin: 0 auto;
  color: #f6e9d4;
  font-size: 17px;
  line-height: 27px;
`
